import { styled } from '@mui/material/styles';
import MuiTextField from '@mui/material/TextField';

export const TextFieldV2 = styled(MuiTextField)(() => ({
  '& .MuiInputBase-root': {
    borderRadius: 0,
    fontSize: '14px',
    fontFamily: 'Calibre',
  },
}));

export const TextFieldProviderLocationsV2 = styled(MuiTextField)(() => ({
  '& .MuiInputBase-root': {
    borderRadius: 0,
    fontSize: '18px',
    fontFamily: 'Calibre-R',
    color: '#596668',
  },

  '& .MuiInputBase-input': {
    fontSize: '18px',
    ':disabled': {
      backgroundColor: '#fff !important',
    },
  },
}));
